import { render, staticRenderFns } from "./CreateDomainForm.vue?vue&type=template&id=5ef20270"
import script from "./CreateDomainForm.vue?vue&type=script&lang=js"
export * from "./CreateDomainForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports